import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import styles from './Redirection.module.css';

export const Redirection = () => {

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const origin = searchParams.get('origin');

  useEffect(() => {

    if (origin !== 'SSO') {

      navigate('/', { replace: true });

    }

  }, [origin, navigate]);

  if (origin !== 'SSO') {

    return null;

  }

  return (
    <div className={styles.page}>

      <div className={styles.card}>

        <div className={styles.iconWrapper}>

          <span className={styles.icon}>✓</span>

        </div>

        <h1 className={styles.title}>
          Videollamada finalizada
        </h1>

        <p className={styles.text}>
          La consulta ha concluido correctamente.
        </p>

        <p className={styles.text}>
          Puedes cerrar esta ventana para regresar a la aplicación.
        </p>

        <div className={styles.instructions}>

          <p className={styles.instructionsTitle}>
            ¿Cómo cerrar?
          </p>

          <p className={styles.instructionsText}>
            Pulsa la <strong>X</strong> de la parte superior o utiliza la flecha de regreso de tu dispositivo para volver a la aplicación.
          </p>

        </div>

      </div>

    </div>
  );

};